import { isArray } from './is-array';

export function isArrayAndNotEmpty(value): boolean {
    return isArray(value) && !!value.length;
}
